import { render, staticRenderFns } from "./LiondeskDialogV2.vue?vue&type=template&id=4bc6c1a7&scoped=true&lang=pug"
import script from "./LiondeskDialogV2.vue?vue&type=script&lang=js"
export * from "./LiondeskDialogV2.vue?vue&type=script&lang=js"
import style0 from "./LiondeskDialogV2.vue?vue&type=style&index=0&id=4bc6c1a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc6c1a7",
  null
  
)

export default component.exports